
angular.module('bmsApp.marketing')
	.directive('marketingCampaignInitiativeSelector', [
		'$q',
		'$timeout',
		'$filter',
		'ConfigService',
		'CampaignSvc',
		'InitiativeSvc',
		'DiscountCodeSvc',
		'MarketingSchemeSvc',
		function (
			$q,
			$timeout,
			$filter,
			ConfigService,
			CampaignSvc,
			InitiativeSvc,
			DiscountCodeSvc,
			MarketingSchemeSvc) {
			return {
				restrict: 'E',
				replace: true,
				templateUrl: 'ng/marketing/templates/MarketingCampaignInitiativeSelector.html',
				scope: {
					savedInitiative: '=',
					campaign: '=',
					initiative: '=',
					discountCode: '=',
					license: '=',
					marketing_scheme: '=marketingScheme',
				},
				link: function (scope) {
					scope.marketing_type = 'local';

					if (angular.isObject(scope.marketing_scheme)) {
						scope.marketing_type = 'remote';
					}

					scope.config = ConfigService.config;
					var campaignParams = {
						filter: {
							savedInitiative: angular.isObject(scope.savedInitiative) ? scope.savedInitiative.id : null
						}
					};
					var initiativeParams = {
						filter: {
							savedInitiative: angular.isObject(scope.savedInitiative) ? scope.savedInitiative.id : null
						}
					};

					var discountCodes;

					scope.typeChanged = function(type) {
						if (type === 'local') {
							scope.marketing_scheme = null;
						}
						else {
							scope.campaign = null;
							scope.initiative = null;
						}
					};

					function updateCampaignList(){

						let schemeParams = {
							filter: {
								license: scope.license ? scope.license.id : 0,
							},
							savedScheme: angular.isObject(scope.marketing_scheme) ? scope.marketing_scheme.id : null,
						};

						angular.extend(campaignParams.filter, {
							license: scope.license ? scope.license.id : 0
						});

						var promises = [
							CampaignSvc.options(campaignParams),
							InitiativeSvc.options(initiativeParams),
							DiscountCodeSvc.index(),
							MarketingSchemeSvc.options(schemeParams),
						];

						$q.all(promises)
							.then(function (responses) {
								$timeout(function () {
									scope.$apply(function () {
										scope.campaignOptions = responses[0].data.campaign_options;
										scope.initiativeOptions = responses[1].data.initiative_options;
										discountCodes = responses[2].data.discount_code_collection;
										scope.schemeOptions = responses[3].data.scheme_options;
									});
								}, 0);
							});
					}

					scope.campaignInitiativeFilterComparator = function (campaign) {
						return function (initiative) {
							if (angular.isObject(campaign)) {
								return initiative.campaign_id == campaign.id;
							}
						};
					};

					var discountCodeComparator = function (code) {
						return function (discountCode) {
							return code.toLowerCase() == discountCode.code.toLowerCase();
						};
					};

					var setInitiative = function (id) {
						// find initiative in options array
						var matches = $filter('filter')(scope.initiativeOptions, {id: id});
						if (matches.length) {
							var initiative = matches[0];
							// set the campaign first
							if (setCampaign(initiative.campaign_id)) {
								// set the initiative
								scope.initiative = initiative;
								return true;
							}
						}
					};

					var setFirstCampaignInitiative = function (campaignId) {
						var matches = $filter('filter')(scope.initiativeOptions, {campaign_id: campaignId}, true);
						if (angular.isDefined(matches) && matches.length) {
							scope.initiative = matches[0];
						}
						else {
							scope.initiative = null;
						}
					};

					var setCampaign = function (id) {
						// find the campaign in options array
						var matches = $filter('filter')(scope.campaignOptions, {id: id});
						if (matches.length) {
							scope.campaign = matches[0];
							return true;
						}
						// set the campaign
					};

					scope.closeCodeAlert = function () {
						scope.codeAlert = false;
					};

					scope.applyCode = function (code) {
						scope.codeApplied = false;
						if (angular.isString(code) && code.length) {
							// matching discount code objects
							var matches = $filter('filter')(discountCodes, discountCodeComparator(code));
							if (matches.length) {
								// match initiative id to an initiative object
								if (setInitiative(matches[0].initative_id)) {
									scope.codeAlert = {
										msg: 'Applied: <strong>' + matches[0].description + '<strong>',
										type: 'success'
									};
									scope.discountCode = angular.copy(matches[0]);
									scope.codeApplied = true;
								}
								else {
									scope.codeAlert = {
										msg: 'Invalid code entered',
										type: 'danger'
									};
								}
							}
							else {
								scope.codeAlert = {
									msg: 'Invalid code entered',
									type: 'danger'
								};
							}
						}
						else {
							scope.codeAlert = {
								msg: 'No code entered',
								type: 'danger'
							};
						}
					};

					scope.removeCode = function () {
						scope.sourceCode = null;
						scope.discountCode = null;
						scope.codeApplied = false;
						scope.codeAlert = null;
					};

					scope.$watch('campaign', function (newValue, oldValue) {
						if (angular.isDefined(scope.campaignOptions)) { // check initiative options have been loaded
							if (angular.isObject(newValue) && angular.isObject(oldValue)) {
								// compare, if different set initiative to first option
								if (newValue.id != oldValue.id) {
									setFirstCampaignInitiative(newValue.id);
								}
							}
							else if (angular.isObject(newValue)) {
								// set initiative to first option
								setFirstCampaignInitiative(newValue.id);
							}
							else {
								// no campaign, unset initiative
								scope.initiative = null;
							}
						}
					});

					scope.$watch('discountCode', function (newValue) {
						if (angular.isObject(newValue) && angular.isDefined(newValue.id)) {
							scope.codeApplied = true;
							scope.sourceCode = angular.copy(newValue.code);
						}
					});

					scope.$watch('license', function(newValue){
						if (angular.isDefined(newValue)){
							if (angular.isObject(scope.campaign) && scope.license.id != scope.campaign.license_type_id){
								scope.campaign = null;
								scope.initiative = null;
							}

							updateCampaignList();
						}
					});
				}
			};
		}]);
